import wixWindow from 'wix-window';

$w.onReady(function () {
  {
  // Перевірте на мобільному чи планшетному пристрої
  if (wixWindow.formFactor === "Desktop")
    // Початково приховуємо і колапсуємо смугу helpukraine
    $w('#helpukraine').collapse();

    let isHoveringOverHelpUkraine = false;

    // Додаємо обробник подій для наведенні миші на flag1
    $w('#flag1').onMouseIn(() => {
        $w('#helpukraine').expand(); // Показуємо і розширюємо смугу helpukraine
    });

    $w('#flag1').onMouseOut(() => {
        // Перевіряємо, чи мишка не знаходиться на helpukraine
        if (!isHoveringOverHelpUkraine) {
            $w('#helpukraine').collapse(); // Ховаємо і колапсуємо смугу helpukraine
        }
    });

    // Додаємо обробник подій для наведенні миші на flag2
    $w('#flag2').onMouseIn(() => {
        $w('#helpukraine').expand(); // Показуємо і розширюємо смугу helpukraine
    });

    $w('#flag2').onMouseOut(() => {
        // Перевіряємо, чи мишка не знаходиться на helpukraine
        if (!isHoveringOverHelpUkraine) {
            $w('#helpukraine').collapse(); // Ховаємо і колапсуємо смугу helpukraine
        }
    });

    // Обробник подій для наведенні миші на helpukraine
    $w('#helpukraine').onMouseIn(() => {
        isHoveringOverHelpUkraine = true; // Мишка знаходиться на helpukraine
    });

    $w('#helpukraine').onMouseOut(() => {
        isHoveringOverHelpUkraine = false; // Мишка пішла з helpukraine
        $w('#helpukraine').collapse(); // Ховаємо смугу, коли мишку прибрано з неї
    });
	}
});

$w.onReady(function () {
  // Перевірте на мобільному чи планшетному пристрої
  if (wixWindow.formFactor === "Mobile") {
    $w('#flag1').onClick(() => {
      $w('#helpukraine').expand();
    });

    $w('#flag2').onClick(() => {
      $w('#helpukraine').expand();
    });
  }
});

import wixLocation from 'wix-location';

$w.onReady(function () {
    // Обробник події натискання на кнопку "help"
    $w('#help').onClick(() => {
        // Отримуємо поточний URL
        const currentUrl = wixLocation.url;

        // Створюємо новий URL з параметром запиту ?modal=допомога-україні
        let newUrl = `${currentUrl}?modal=допомога-україні`;

        // Перевіряємо, чи вже існують параметри в URL
        if (currentUrl.includes("?")) {
            newUrl = `${currentUrl}&modal=допомога-україні`;
        }

        // Перенаправляємо користувача на новий URL
        wixLocation.to(newUrl);
    });
});
